module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/stores/1_20926d55bf4dfa395849301b67d70597.jpg";